import React, { useState } from 'react'
import './socialmedia.css'

import { SocialIcon } from 'react-social-icons';

const SocialMedia = () => {

  const [isActive, setIsActive] = useState(false);

  const activeSocialMedia = () => {
    // console.log(isActive)
    setIsActive(!isActive)
  }

  return (
    <div id="circularMenu1" className={isActive ? "circular-menu circular-menu-left active" : "circular-menu circular-menu-left"}>

      <a className="floating-btn" onClick={() => activeSocialMedia()}>
        <i className="fa-solid fa-plus"></i>

      </a>

      <menu className="items-wrapper">
        <a className="menu-item" target={"_blank"}  onClick={(e) => {
          e.preventDefault();
          window.location.href = "mailto:laconsolamendoza@gmail.com?body=Buen día, solicito soporte por via E-mail";
        }}><i className="fas fa-envelope"></i></a>
        <a className="menu-item" href="https:/t.me/LaConsola" target={"_blank"}><i className=" fa-brands fa-telegram"></i></a>
        <a className='menu-item' href="https://www.tiktok.com/@laconsola.digital" target={"_blank"}><i className="fa-brands fa-tiktok"></i></a>
        <a className='menu-item' href="https://www.instagram.com/laconsola.dig/" target={"_blank"}><i className=" fa-brands fa-instagram"></i></a>
      </menu>

    </div>
  )
}

export default SocialMedia